module.exports = __webpack_public_path__ + "img/console01.af0e1faa.jpg";